import { useUserSettingsContext } from "../../../../contexts/userSettingsContext";
import { PHRASES_DICTIONARY } from "../../../../entities/phrasesDictionary";
import { properties } from "../../../../entities/properties";
import { StyledCleanCacheText, StyledSettingsBtn } from "./actionButtonByRole.style";

const ActionButtonByRole = ({ fetchClearCache }) => {

    const { currentUserRoles } = useUserSettingsContext();

    const necessaryRoles = currentUserRoles.some((role) => properties.adminRoles.includes(role));

    return (
        <StyledSettingsBtn
            className="btn-color"
            onClick={() => { fetchClearCache() }}
            disabled={!necessaryRoles}
        >
            <span>Clean cache</span>
            <StyledCleanCacheText>
                {necessaryRoles
                    ? PHRASES_DICTIONARY.CLEAN_CACHE_BTN_TEXT.with_necessary_roles
                    : PHRASES_DICTIONARY.CLEAN_CACHE_BTN_TEXT.without_necessary_roles
                }
            </StyledCleanCacheText>
        </StyledSettingsBtn>
    )
}

export default ActionButtonByRole;